/**
 * @roadbridge/pass-content — public entry point.
 *
 * Shared traveler-pack content for the SP2 "vacationer" track. Source-only:
 * apps/web and apps/marketing import these packs directly via Vite.
 *
 * Import surface:
 *   import { PACKS, getPack, listPacks, validatePassContent } from '@roadbridge/pass-content';
 *   import type { TravelerPack, Rule, TripChecklists } from '@roadbridge/pass-content';
 */
import type { TravelerPack } from './types.js'
import { IT } from './data/it.js'
import { CH } from './data/ch.js'
import { FR } from './data/fr.js'
import { US } from './data/us.js'

export const PACKS = { IT, CH, FR, US } as const

export type PackId = keyof typeof PACKS

export function getPack(id: PackId): TravelerPack {
  return PACKS[id]
}

export function listPacks(): TravelerPack[] {
  return Object.values(PACKS)
}

export { validatePassContent } from './validate.js'

export type {
  JurisdictionType,
  Jurisdiction,
  RuleCategory,
  Severity,
  Rule,
  QuickFacts,
  ChecklistItem,
  TripChecklists,
  Lesson,
  Course,
  EmergencyCard,
  TravelerPack,
} from './types.js'
